import { appHistory } from '@wolffun/app-manager/src/utils/history';
import { MenuItem, RouteName } from './types';
export { MenuItem } from './types';
export let InventoryCategoryKey;

(function (InventoryCategoryKey) {
  InventoryCategoryKey["Heroes"] = "heroes";
  InventoryCategoryKey["Pets"] = "pets";
  InventoryCategoryKey["ThetaBox"] = "thetabox";
  InventoryCategoryKey["GiftBox"] = "giftbox";
  InventoryCategoryKey["Cosmetic"] = "cosmetic";
  InventoryCategoryKey["Others"] = "others";
})(InventoryCategoryKey || (InventoryCategoryKey = {}));

export let CategoryKey;

(function (CategoryKey) {
  CategoryKey["TransactionHistory"] = "transaction-history";
  CategoryKey["BalanceHistory"] = "balance-history";
  CategoryKey["HeroHistory"] = "hero-history";
  CategoryKey["CosmeticHistory"] = "cosmetic-history";
  CategoryKey["BoxHistory"] = "box-history";
  CategoryKey["RentalHistory"] = "rental-history";
  CategoryKey["VestingSafeHistory"] = "vesting-safe-history";
})(CategoryKey || (CategoryKey = {}));

export const constructSearchQuery = params => {
  const {
    urlSearch,
    tab,
    category
  } = params;
  const searchQuery = new URLSearchParams(urlSearch); // we use UrlSearch for a default value because it's a normalized string

  if (tab) {
    searchQuery.set('tab', tab);
  }

  if (category) {
    searchQuery.set('category', category);
  }

  return searchQuery.toString();
};
export const navigateToConnectWallet = ({
  backTo,
  redirectTo,
  isNewTab
}) => {
  if (isNewTab) {
    openNewTab('/connect');
    return;
  }

  appHistory.history.push({
    pathname: '/connect',
    state: {
      redirectTo,
      backTo
    }
  });
};
export const navigateToThetanBox = params => {
  const {
    isNewTab
  } = params || {};

  if (isNewTab) {
    openNewTab('/thetanbox');
    return;
  }

  appHistory.history.push({
    pathname: '/thetanbox'
  });
};

const openNewTab = (path, search) => {
  if (search) {
    window.open(`${path}?${search}`, '_blank');
    return;
  }

  window.open(path, '_blank');
};

export const navigateToProfile = (tab, params, category) => {
  const {
    isNewTab
  } = params || {};
  const searchQuery = constructSearchQuery({
    tab,
    category
  });

  if (isNewTab) {
    openNewTab('/profile', searchQuery);
    return;
  }

  appHistory.history.push({
    pathname: '/profile',
    search: searchQuery
  });
};
export const navigateToHistoryPage = params => {
  const {
    urlSearch,
    tab,
    category
  } = params;
  const searchQuery = constructSearchQuery({
    urlSearch,
    tab,
    category
  });
  appHistory.history.push({
    pathname: '/profile',
    search: searchQuery
  });
};
export const navigateToInGamePage = params => {
  const {
    urlSearch,
    category
  } = params;
  const searchQuery = constructSearchQuery({
    urlSearch,
    tab: MenuItem.IN_GAME,
    category
  });
  appHistory.history.push({
    pathname: '/profile',
    search: searchQuery
  });
};
export const navigateToHeroDetail = (id, state) => {
  appHistory.history.push({
    pathname: `item/${id}`,
    state: state
  });
};
export const navigateToDailyQuest = param => {
  const {
    isNewTab,
    section
  } = param || {};

  if (isNewTab) {
    openNewTab(RouteName.DailyQuest + (section ? section : ''));
    return;
  }

  appHistory.history.push({
    pathname: RouteName.DailyQuest + (section ? section : '')
  });
};